import { render, staticRenderFns } from "./FormCheckBoxField.vue?vue&type=template&id=b9774720&scoped=true&"
import script from "./FormCheckBoxField.vue?vue&type=script&lang=ts&"
export * from "./FormCheckBoxField.vue?vue&type=script&lang=ts&"
import style0 from "./FormCheckBoxField.vue?vue&type=style&index=0&id=b9774720&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9774720",
  null
  
)

export default component.exports